import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

// export const fetchClients = async ({
//   limit,
//   page,
//   filters,
//   sort,
//   ret,
//   ref,
//   incl,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     // Make both API calls concurrently
//     const [clientsResponse, totalCountResponse] = await Promise.all([
//       // Fetch paginated clients
//       axios.get(ENDPOINTS.CLIENTS.GET_ALL, {
//         params: {
//           coll: "Client",
//           lim: limit,
//           pg: page,
//           fil: JSON.stringify(filters),
//           cache: false,
//           sort: JSON.stringify(sort),
//           ret: ret,
//           ref: ref,
//           incl: incl,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }),

//       // Fetch total count
//       axios.get(ENDPOINTS.CLIENTS.GET_TOTAL_COUNT, {
//         params: {
//           coll: "Client",
//           fil: JSON.stringify(filters),
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }),
//     ]);
//     return {
//       data: clientsResponse.data,
//       totalCount: totalCountResponse.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     if (error.response?.status === 401) {
//       // Handle unauthorized error (e.g., redirect to login)
//     }
//     throw error;
//   }
// };
// export const fetchOneClient = async ({ clientUiid, retrieve, ref, incl }) => {
//   try {
//     const token = localStorage.getItem("token");
//     const response = await axios.get(ENDPOINTS.CLIENTS.GET_BY_UIID, {
//       params: {
//         coll: "Client",
//         ret: retrieve,
//         ref: ref,
//         fil: JSON.stringify({ uiid: { type: "NONE", value: clientUiid } }),
//         incl: incl,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       withCredentials: true,
//     });

//     return response.data;
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     if (error.response?.status === 401) {
//       // Handle unauthorized error (e.g., redirect to login)
//     }
//     throw error;
//   }
// };
// export const addNewClient = async (clientData) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.post(
//       ENDPOINTS.CLIENTS.ADD_NEW,
//       {
//         coll: "Client",
//         payload: clientData,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to add new client",
//     };
//   }
// };
// export const updateClient = async ({ coll, uiid, payload, patchId, tPath }) => {
//   try {
//     const token = localStorage.getItem("token");
//     const params = new URLSearchParams({
//       coll,
//       uiid,
//       ...(patchId && { patchId }),
//       ...(tPath && { tPath }),
//     });
//     const response = await axios.patch(
//       `${ENDPOINTS.CLIENTS.UPDATE}?${params.toString()}`,
//       // { payload: payload },
//       { payload },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error);
//     return {
//       success: false,
//       // error: error.message || "Failed to update client",
//       error: error?.response?.data?.error || "Failed to update client",
//     };
//   }
// };
// export const addContact = async (payload) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.post(
//       `${ENDPOINTS.CLIENTS.ADD_CONTACT}`,
//       {
//         coll: `Contact`,
//         bulkPost: true,
//         payload: payload,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to add contact",
//     };
//   }
// };
// export const updateContact = async ({ coll, uiid, payload }) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.patch(
//       `${ENDPOINTS.CLIENTS.UPDATE_CONTACT}?coll=${coll}&uiid=${uiid}`,
//       { payload },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data.doc,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error?.response?.data?.error || "Failed to update contact",
//     };
//   }
// };

// import { ENDPOINTS } from "../../apiConfig";

// export const fetchClients = async ({ limit, page, filters }) => {
//   try {
//     const token = localStorage.getItem("token"); // Get token from localStorage

//     const response = await axios.get(ENDPOINTS.CLIENTS.GET_ALL, {
//       params: {
//         coll: "Client",
//         lim: limit,
//         pg: page,
//         fil: JSON.stringify(filters),
//         cache: false,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`, // Add authorization header
//         "Content-Type": "application/json",
//       },
//       withCredentials: true, // Include cookies if using session-based auth
//     });

//     //console.log("API Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     if (error.response?.status === 401) {
//       // Handle unauthorized error (e.g., redirect to login)
//       //console.log("Unauthorized access - please login");
//     }
//     throw error;
//   }
// };

/// update code
export const fetchClients = async ({ limit, page, filters, sort, ret, ref, incl }) => {
  try {
    const [clientsResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.CLIENTS.GET_ALL,
        params: {
          coll: "Client",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.CLIENTS.GET_TOTAL_COUNT,
        params: {
          coll: "Client",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      data: clientsResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Fetch one client by UIID
export const fetchOneClient = async ({ clientUiid, retrieve, ref, incl }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CLIENTS.GET_BY_UIID,
    params: {
      coll: "Client",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({ uiid: { type: "NONE", value: clientUiid } }),
      incl,
    },
  });
};
export const addNewClient = async (clientData) => {
  return await axiosRequest({
    method: 'POST',
    url: ENDPOINTS.CLIENTS.ADD_NEW,
    data: {
      coll: 'Client',
      payload: clientData,
    },
  });
};
export const updateClient = async ({ coll, uiid, payload, patchId, tPath }) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: 'PATCH',
    url: ENDPOINTS.CLIENTS.UPDATE,
    data: { payload },
    params,
  });
};


export const addContact = async (payload) => {
  return await axiosRequest({
    method: 'POST',
    url: ENDPOINTS.CLIENTS.ADD_CONTACT,
    data: {
      coll: 'Contact',
      bulkPost: true,
      payload,
    },
  });
};

export const updateContact = async ({ coll, uiid, payload }) => {
  return await axiosRequest({
    method: 'PATCH',
    url: ENDPOINTS.CLIENTS.UPDATE_CONTACT,
    data: { payload },
    params: { coll, uiid },
  });
};
